import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import HomeEditor from "./HomeEditor";
import TestimonialsEditor from "./TestimonialsEditor";
import PlansEditor from "./PlansEditor";
import FaqsEditor from "./FaqsEditor";
import ArticlesEditor from "./ArticlesEditor";
import GlobalEditor from "./GlobalEditor";
import SeoEditor from "./SeoEditor";
import AdminUsers from "./AdminUsers";

const TABS = [
  ["home", "Homepage", HomeEditor],
  ["testimonials", "Customer Feedback", TestimonialsEditor],
  ["plans", "Pricing", PlansEditor],
  ["faqs", "FAQs", FaqsEditor],
  ["articles", "Blog", ArticlesEditor],
  ["global", "Contact & Global", GlobalEditor],
  ["seo", "SEO", SeoEditor],
  ["admins", "Admin Users", AdminUsers],
];

export default function WebsiteEditor() {
  return (
    <Tabs defaultValue="home" data-testid="website-editor">
      <TabsList className="flex flex-wrap h-auto gap-1 mb-6 bg-slate-100 p-1 rounded-xl justify-start">
        {TABS.map(([v, label]) => (
          <TabsTrigger key={v} value={v} data-testid={`editor-tab-${v}`} className="rounded-lg data-[state=active]:bg-emerald-700 data-[state=active]:text-white">{label}</TabsTrigger>
        ))}
      </TabsList>
      {TABS.map(([v, , C]) => <TabsContent key={v} value={v}><C /></TabsContent>)}
    </Tabs>
  );
}
